import React, { SVGProps } from 'react'
const SvgReceiptMissing = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <g fill={props.fill || '#EB505B'} clipPath="url(#Receipt-Missing_svg__a)">
      <path
        fillRule="evenodd"
        d="M5.963 3.938a.713.713 0 0 0-.713.713v15.837l2.92-2.695a.803.803 0 0 1 1.017-.06l2.825 2.055 2.568-2.053a.803.803 0 0 1 .922-.057l2.998 1.844V4.652a.713.713 0 0 0-.713-.714H5.963Zm-1.713.713c0-.946.767-1.713 1.713-1.713h11.824c.946 0 1.713.767 1.713 1.713v15.224a.803.803 0 0 1-1.224.684l-3.18-1.957-2.576 2.061a.803.803 0 0 1-.974.023l-2.817-2.049-3.131 2.89a.803.803 0 0 1-1.348-.59V4.651Z"
        clipRule="evenodd"
      />
      <path d="M11.558 13.12a.212.212 0 0 1-.14-.05.204.204 0 0 1-.06-.15v-.32c.026-.26.096-.49.21-.69.12-.207.256-.393.41-.56.16-.173.316-.337.47-.49a3.4 3.4 0 0 0 .4-.45.997.997 0 0 0 .2-.47.672.672 0 0 0-.12-.49.845.845 0 0 0-.39-.3 1.21 1.21 0 0 0-.51-.11c-.314 0-.57.077-.77.23-.2.153-.337.4-.41.74a.336.336 0 0 1-.1.18.32.32 0 0 1-.19.05h-.85a.239.239 0 0 1-.16-.06.267.267 0 0 1-.06-.18c.006-.267.066-.523.18-.77.12-.253.29-.48.51-.68.226-.2.5-.357.82-.47.32-.12.686-.18 1.1-.18.453 0 .833.06 1.14.18.313.113.56.263.74.45.186.187.32.39.4.61.08.213.116.423.11.63-.014.253-.07.48-.17.68-.1.2-.224.387-.37.56-.147.167-.297.333-.45.5-.154.16-.29.323-.41.49a1.494 1.494 0 0 0-.26.71l-.02.16a.562.562 0 0 1-.1.19c-.04.04-.097.06-.17.06h-.98Zm-.03 1.88a.231.231 0 0 1-.17-.07.232.232 0 0 1-.07-.17v-.87c0-.073.023-.133.07-.18a.232.232 0 0 1 .17-.07h.97c.073 0 .133.023.18.07.046.047.07.107.07.18v.87a.231.231 0 0 1-.07.17.243.243 0 0 1-.18.07h-.97Z" />
    </g>
    <defs>
      <clipPath id="Receipt-Missing_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgReceiptMissing
